// extracted by mini-css-extract-plugin
export var billingAddress = "_y7-g";
export var contactInfo = "_y7-d";
export var customerInfoContainer = "_y7-c";
export var customerInfoContainerMobile = "_y7-h";
export var customerInfoRow = "_y7-a";
export var customerInfoSection = "_y7-b";
export var fullWidthDividerMobile = "_y7-i";
export var imageContainer = "_y7-1";
export var paymentMethod = "_y7-e";
export var priceText = "_y7-6";
export var priceTextMobile = "_y7-7";
export var product = "_y7-0";
export var productImage = "_y7-2";
export var productInfo = "_y7-4";
export var productMobile = "_y7-9";
export var productTitle = "_y7-8";
export var quantityBadge = "_y7-3";
export var quantityText = "_y7-5";
export var shippingAddress = "_y7-f";